import { useState } from "react";
import { HttpVenueClient } from "../../../clients/http-venue-client.js";
import { LangContext, type Lang } from "../../../lib/i18n.js";
import { MatchFlow } from "../../matching/components/MatchFlow.js";
import { readGenericMatchShare } from "../../matching/generic-match-share.js";
import { SiteFooter, SiteHeader } from "../components/SiteHeader.js";
import { useSeo } from "../useSeo.js";

const client = new HttpVenueClient();

export function GlobalMatchPage() {
  const [shared] = useState(() => readGenericMatchShare(window.location.search));
  const [locale, setLocale] = useState<Lang>(() => shared?.result.locale ?? "en");
  const zh = locale === "zh";
  useSeo("Match your vibe — Vibetail", "Get a cocktail created for your mood.");
  return <LangContext.Provider value={locale}><div className="vt-page"><SiteHeader /><main className="vt-match-main">
    <MatchFlow
      context={{
        kicker: zh ? "为今晚临时创作" : "A cocktail made for your mood",
        title: zh ? "找到今晚这一杯" : "Match your vibe",
        description: zh ? "告诉我们今晚想要什么感觉，让调酒师为你创作一杯。" : "Tell us how the night should feel. We'll create a cocktail just for you.",
      }}
      generic
      {...(shared ? { initialPreferences: shared.preferences, initialResult: shared.result } : {})}
      headerAction={<button className="vt-locale-toggle" type="button" onClick={() => setLocale((v) => v === "en" ? "zh" : "en")}>{locale === "en" ? "中文" : "EN"}</button>}
      onLocaleToggle={() => setLocale((v) => v === "en" ? "zh" : "en")}
      match={(preferences, lang) => client.matchGlobalCocktail(preferences, lang)}
    />
  </main><SiteFooter /></div></LangContext.Provider>;
}
